import { render, staticRenderFns } from "./v-main.vue?vue&type=template&id=33c5972f&"
import script from "./v-main.vue?vue&type=script&lang=js&"
export * from "./v-main.vue?vue&type=script&lang=js&"
import style0 from "./v-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports